import React,{Component} from 'react';
import IndicatorButton from '../../components/IndicatorButton';
import {requestPasswordReset,login} from '../../actions/authActions';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {isValidEmail} from '../../utils/Validators';
import {showError,showMessage} from '../../actions/uiActions';

class PasswordResetRequestForm extends Component
{
    state=
    {
        email:'',
        active:false,
        valid_email:true
    }
    
    handleOnChange=(e)=>
    {
        this.setState({[e.target.name]:e.target
        .value,valid_email:true});
    }

    handleOnSubmit=(e)=>
    {
        if(e)
            e.preventDefault();
        const emailIsValid=isValidEmail(this.state.email);
        this.setState({valid_email:emailIsValid,active:emailIsValid});
        if(emailIsValid)
            this.props.requestPasswordReset(this.state.email);
        
    }
    render()
    {
        return <div className="container login"><div className="row"><div className="col-xl-4 offset-xl-4 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-12"><div className="mat-card animated fadeIn">
        {(!this.props.reset_request_error&&!this.props.reset_request_success&&
        <div>
        <h1>Reset Password</h1>
        <p>Enter your email address to receive instructions to reset your account password.</p>
        <form  onSubmit={this.handleOnSubmit}>
            <div className="form-group dark">
            <input disabled={this.state.sending} type="email" name="email" value={this.state.email} onChange={this.handleOnChange} className="form-control branded-dark-input" placeholder="Your Email Address" />
            {!this.state.valid_email&&<div className="input-error animated zoomIn">Enter a valid email address</div>}
            </div>
        </form>
        <div className="actions">
        <button disabled={this.state.authenticating} onClick={this.props.login} className="link align-left ">Cancel</button>
        <IndicatorButton disabled={this.state.sending} className="btn-primary btn-material" onClick={this.handleOnSubmit}>Submit</IndicatorButton>
        </div>
        </div>)||(this.props.reset_request_success&&<div><p className="info animated fadeIn">Your request has been received. If you have an account with us, you will receive an email with instructions to reset your account password.</p><div className="row"><div className="col-12 text-center"><button className="btn btn-primary" onClick={this.props.login}>Go to Login</button></div></div></div>)||(this.props.reset_request_error&&<div><p className="info animated fadeIn">There has been an error processing your request, please refresh the page and try again.</p></div>)}
        </div></div></div>
        </div>

    }
}
const mapStateToProps= state =>{
    return {
        reset_request_error:state.auth.reset_request_error,
        reset_request_success:state.auth.reset_request_success,
        requestPasswordReset:requestPasswordReset,
        login:login
    }};
PasswordResetRequestForm.propTypes=
{
    reset_request_error: PropTypes.bool,
    reset_request_success:PropTypes.bool,
    requestPasswordReset:PropTypes.func.isRequired,
    login:PropTypes.func.isRequired
};
export default connect(mapStateToProps,{requestPasswordReset,login,showError,showMessage})(PasswordResetRequestForm);